var map = {
	"./asset12-50.jpg": 89885,
	"./asset13-50.jpg": 99105,
	"./asset14-50.jpg": 19131,
	"./asset15-50.jpg": 55062,
	"./asset16-50.jpg": 54407,
	"./asset17-50.jpg": 87119,
	"./asset18-50.jpg": 34823,
	"./pratinidhi.jpeg": 97214,
	"./premature-day.jpeg": 11989,
	"./prematuritydaymysore.jpg": 68404,
	"./prematuritydayramanagara.jpg": 44570,
	"./press-1.jpg": 88588,
	"./press-10.jpeg": 32165,
	"./press-11.jpeg": 81658,
	"./press-12.jpeg": 15081,
	"./press-2.jpg": 26901,
	"./press-3.jpg": 54359,
	"./press-4.jpg": 25457,
	"./press-5.jpg": 82689,
	"./press-6-old.jpeg": 61046,
	"./press-6.jpeg": 65055,
	"./press-7.jpeg": 70896,
	"./press-8.jpeg": 79338,
	"./press-8.png": 93851,
	"./press-9.jpeg": 48193,
	"./press-new-1.jpeg": 37767,
	"./press-new-2.jpeg": 83424,
	"./press-new-3.jpeg": 89342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34461;